import {makeAutoObservable} from 'mobx';


export default class result8Store {
    constructor() {
        this._cols8 = {}
        this._result8 = 0
        this._word8 = ''
        makeAutoObservable(this);
    }

    setCols8(cols) {
        this._cols8 = cols;
    }

    setResult8(result) {
        this._result8 = result;
    }

    setWord8(word) {
        this._word8 = word;
    }

    get cols8() {
        return this._cols8
    }

    get result8() {
        return this._result8
    }

    get word8() {
        return this._word8
    }
}

